import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useTheme } from '../../context/ThemeContext';

const NAV_LINKS = ['Home', 'About Me', 'Services', 'Projects', 'Contact'];

export default function Navbar() {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const [showHint, setShowHint]   = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleThemeToggle = () => {
    toggleTheme();
  };

  const scrollTo = (link) => {
    setMenuOpen(false);
    const id = link.toLowerCase().replace(' ', '-');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>

        {/* ── DESKTOP: centered pill ── */}
        <div className="navbar__pill">
          {NAV_LINKS.map((link) => (
            <button
              key={link}
              className="navbar__link"
              onClick={() => scrollTo(link)}
            >
              {link}
            </button>
          ))}
          <button
            className="navbar__hire"
            onClick={() => scrollTo('contact')}
          >
            Hire Me
          </button>
          <div className="navbar__theme-wrap">
            <button
              className={`navbar__theme-toggle ${theme === 'light' ? 'navbar__theme-toggle--pulse' : ''}`}
              onClick={handleThemeToggle}
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? '☀' : '☾'}
            </button>
            {theme === 'light' && (
              <div className="navbar__theme-hint">
               Try Dark Mode
                <span className="navbar__theme-hint-arrow" />
              </div>
            )}
          </div>
        </div>

        {/* ── MOBILE: name + hamburger ── */}
        <div className="navbar__mobile">
          <span className="navbar__mobile-name">Renzly M.</span>
          <div className="navbar__mobile-right">
            <button
              className="navbar__theme-toggle navbar__theme-toggle--mobile"
              onClick={handleThemeToggle}
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? '☀' : '☾'}
            </button>
            <button
              className={`navbar__ham ${menuOpen ? 'navbar__ham--open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>

      </nav>

      {/* ── MOBILE DRAWER ── */}
      <div className={`navbar__drawer ${menuOpen ? 'navbar__drawer--open' : ''}`}>
        <div className="navbar__drawer-inner">
          {NAV_LINKS.map((link, i) => (
            <button
              key={link}
              className="navbar__drawer-link"
              style={{ animationDelay: `${i * 0.06}s` }}
              onClick={() => scrollTo(link)}
            >
              <span className="navbar__drawer-dot" />
              {link}
            </button>
          ))}
          <button
            className="navbar__drawer-hire"
            onClick={() => scrollTo('contact')}
          >
            Hire Me
          </button>
          <button
            className="navbar__drawer-theme"
            onClick={handleThemeToggle}
          >
            {theme === 'dark' ? '☀ Switch to Simple' : '☾ Switch to Dark Neon'}
          </button>
        </div>
      </div>

      {/* Backdrop */}
      {menuOpen && (
        <div
          className="navbar__backdrop"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </>
  );
}